/* eslint complexity: ["error", 40] */

import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter, Redirect} from 'react-router-dom';
import {Button, Container, Fade, Form, Modal} from 'react-bootstrap';
import {Formik} from 'formik';
import CommonMetaTag from './common-meta-tag';
import Configuration from '../config';
import {useTranslation} from 'react-i18next';

import {FilePond} from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import {hideSponsorModal, showSponsorModal, saveSponsor, newSponsor, sponsorSelected, deleteSponsorImageFile, getSponsors, deleteSponsor} from '../actions/admin';
import {sponsorType, imageTypes} from '../constants';

import advBanner from '../images/3_pubblicita_ADV.png';
import {FaBullhorn, FaExternalLinkAlt, FaGlobeEurope, FaHandshake, FaMapMarkerAlt, FaPlus, FaSave, FaTrashAlt} from 'react-icons/fa';

const AdminSponsor = ({
  token,
  isSponsorModalVisible,
  hideSponsorModal,
  newSponsorModal,
  showSponsorModal,
  createSponsor,
  sponsors,
  selectedSponsor,
  removeFile,
  deleteSponsor
}) => {
  const {t} = useTranslation();
  if (token === null) {
    return (
      <Redirect to="/login"/>
    );
  }

  const imageBanner = (selectedSponsor ? selectedSponsor.image || [] : []).map(f => {
    return {
      source: f,
      options: {
        type: 'local'
      }
    };
  });

  const sponsorGroups = [
    {icon: <FaGlobeEurope aria-hidden="true"/>, info: t('SPONSOR_GLOBAL_INFO'), title: t('SPONSOR_GLOBAL'), type: sponsorType.global},
    {icon: <FaMapMarkerAlt aria-hidden="true"/>, info: t('SPONSOR_LOCAL_INFO'), title: t('SPONSOR_LOCAL'), type: sponsorType.local}
  ];

  return (
    <Fragment>
      <CommonMetaTag/>
      <Fade in appear className="bg_white" style={{transition: 'opacity 0.30s linear', minHeight: 1000}}>
        <Container fluid className="presentation-container">
          <div className="page-header header-filter clear-filter replayer_adv_sponsor_hero" data-parallax="true">
            <div className="replayer_adv_sponsor_hero_overlay_rp"/>
          </div>
          <div className="main main_raised_rp sponsor-skywork-page sponsor-skywork-admin">
            <div className="section">
              <div className="container sponsor-skywork-shell">
                <header className="sponsor-skywork-hero">
                  <div className="sponsor-skywork-hero-copy">
                    <span className="sponsor-skywork-eyebrow"><FaBullhorn aria-hidden="true"/> GESTIONE SPONSOR</span>
                    <h1>{t('SPONSOR_REPLAYER_ADV')}</h1>
                    <p>{t('SPONSOR_INFO')}</p>
                    <a className="sponsor-skywork-link" href="https://www.replayer.it/it/replayeradv-diventa-sponsor/" target="_blank" rel="noopener noreferrer">
                      {t('SPONSOR_MORE_INFO')} ReplayerAdv <FaExternalLinkAlt aria-hidden="true"/>
                    </a>
                  </div>
                  <Button className="sponsor-skywork-primary sponsor-skywork-create" onClick={newSponsorModal}><FaPlus aria-hidden="true"/> {t('SPONSOR_CREATE')}</Button>
                </header>

                {sponsorGroups.map(group => {
                  const groupSponsors = sponsors.filter(s => s.sponsorType === group.type);
                  return (
                    <section className="sponsor-skywork-section" key={group.type}>
                      <div className="sponsor-skywork-section-head">
                        <span className="sponsor-skywork-section-icon">{group.icon}</span>
                        <div><h2>{group.title}</h2><p>{group.info}</p></div>
                      </div>
                      <div className="sponsor-skywork-grid">
                        {groupSponsors.map(s => (
                          <button type="button" key={s.uid} className="sponsor-skywork-card sponsor-skywork-manage-card" onClick={showSponsorModal(s)}>
                            <div className="sponsor-skywork-card-media">
                              {s.image && s.image.length > 0
                                ? <img src={`${Configuration.apiEndPoint}/sponsors/${s.id}/image?load=${s.image[0]}`} alt={s.name || t('LOGO')}/>
                                : <span className="sponsor-skywork-placeholder"><FaBullhorn aria-hidden="true"/></span>}
                            </div>
                            <div className="sponsor-skywork-card-footer">
                              <strong>{s.name}</strong><span>{t('OPEN_AND_EDIT')}</span>
                            </div>
                          </button>
                        ))}
                        {groupSponsors.length === 0 ? <div className="sponsor-skywork-empty">{t('NO_SPONSORS_IN_SECTION')}</div> : null}
                      </div>
                    </section>
                  );
                })}

                <section className="sponsor-skywork-cta">
                  <div className="sponsor-skywork-cta-copy">
                    <span className="sponsor-skywork-section-icon"><FaHandshake aria-hidden="true"/></span>
                    <div><h2>{t('SPONSOR_BECOME')}</h2><p>{t('SPONSOR_BECOME_INFO')}</p><p>{t('SPONSOR_BECOME_MORE_INFO')} ReplayerAdv.</p></div>
                  </div>
                  <img src={advBanner} alt="ReplayerAdv"/>
                </section>
              </div>
            </div>
          </div>
        </Container>
      </Fade>
      {
        isSponsorModalVisible ?
          <Modal show={isSponsorModalVisible} onHide={hideSponsorModal} dialogClassName="sponsor-skywork-modal">
            <Modal.Header closeButton>
              <Modal.Title>{t('SPONSOR')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={selectedSponsor}
                onSubmit={createSponsor}
              >
                {({
                  handleSubmit,
                  handleChange,
                  setFieldValue,
                  values
                }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Form.Group>
                        <Form.Label>{t('SPONSOR_TYPE')}*</Form.Label>
                        <Form.Check required name="sponsorType" type="radio" label={t('SPONSOR_GLOBAL')} checked={values.sponsorType === sponsorType.global} onChange={() => setFieldValue('sponsorType', sponsorType.global)}/>
                        <Form.Check required name="sponsorType" type="radio" label={t('SPONSOR_LOCAL')} checked={values.sponsorType === sponsorType.local} onChange={() => setFieldValue('sponsorType', sponsorType.local)}/>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>{t('SPONSOR_NAME')}</Form.Label>
                        <Form.Control required name="name" placeholder={t('SPONSOR_NAME')} type="text" maxLength="100" value={values.name || ''} onChange={handleChange}/>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>{t('SPONSOR_LINK')}</Form.Label>
                        <Form.Control name="link" placeholder={t('SPONSOR_LINK')} type="text" maxLength="100" value={values.link || null} onChange={handleChange}/>
                      </Form.Group>
                      <Button className="sponsor-skywork-primary" type="submit"><FaSave aria-hidden="true"/> {t('SAVE')}</Button>
                      {
                        selectedSponsor.id ?
                          <Button variant="danger" className="sponsor-skywork-danger float-right" type="button" onClick={deleteSponsor(selectedSponsor.id)}><FaTrashAlt aria-hidden="true"/> {t('DELETE')}</Button> :
                          null
                      }
                    </Form>
                  );
                }}
              </Formik>
              {
                selectedSponsor.id ?
                  <Fragment>
                    <Form.Label>{t('LOGO')}</Form.Label>
                    <Form.Text className="text-muted">{t('IMAGES_SIZE', {size1: '512', size2: '170'})}</Form.Text>
                    <FilePond
                      files={imageBanner}
                      server={
                        {
                          url: `${Configuration.apiEndPoint}/`,
                          process: {
                            url: `./sponsors/${selectedSponsor.id}/image`,
                            ondata: formData => {
                              formData.append('image_type', imageTypes.sponsor);
                              return formData;
                            }
                          },
                          revert: `./sponsors/${selectedSponsor.id}/image`,
                          restore: `./sponsors/${selectedSponsor.id}/image`,
                          fetch: `./sponsors/${selectedSponsor.id}/image`,
                          load: `./sponsors/${selectedSponsor.id}/image?load=`,
                          headers: {Authorization: `Bearer ${token}`},
                          remove: (source, load) => {
                            removeFile(source, selectedSponsor.id);
                            load();
                          }
                        }
                      }
                    />
                  </Fragment> :
                  null
              }
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={hideSponsorModal}>
                {t('CLOSE_BUTTON')}
              </Button>
            </Modal.Footer>
          </Modal> :
          null
      }
    </Fragment>
  );
};

AdminSponsor.propTypes = {
  token: PropTypes.string,
  isSponsorModalVisible: PropTypes.bool.isRequired,
  hideSponsorModal: PropTypes.func.isRequired,
  newSponsorModal: PropTypes.func.isRequired,
  showSponsorModal: PropTypes.func.isRequired,
  createSponsor: PropTypes.func.isRequired,
  sponsors: PropTypes.array,
  selectedSponsor: PropTypes.object,
  removeFile: PropTypes.func.isRequired,
  deleteSponsor: PropTypes.func.isRequired
};

AdminSponsor.defaultProps = {
  token: null,
  sponsors: [],
  selectedSponsor: null
};

const mapStateToProps = ({login: {token}, admin: {isSponsorModalVisible, sponsors, selectedSponsor}}) => ({
  token,
  isSponsorModalVisible,
  sponsors,
  selectedSponsor
});

const mapDispatchToProps = dispatch => ({
  hideSponsorModal: () => {
    dispatch(getSponsors());
    dispatch(hideSponsorModal());
  },
  newSponsorModal: () => {
    dispatch(newSponsor());
    dispatch(showSponsorModal());
  },
  showSponsorModal: sponsor => () => {
    dispatch(sponsorSelected(sponsor));
    dispatch(showSponsorModal());
  },
  createSponsor: values => {
    dispatch(saveSponsor(values));
  },
  removeFile: (fileName, sponsorId) => {
    dispatch(deleteSponsorImageFile(fileName, sponsorId));
  },
  deleteSponsor: sponsorId => () => {
    dispatch(deleteSponsor(sponsorId));
  }
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminSponsor));
